import { useQuery } from "@tanstack/react-query";
import { getPublicConfig } from "../openapi/api-client.ts";

/**
 * Die Kontaktadressen kommen aus der Backend-Konfiguration, nicht aus dem
 * Bundle: das Frontend wird im Image gebaut, ein eingebauter Wert liesse sich
 * nur mit einem neuen Build aendern. So genuegt eine Environment-Variable.
 *
 * `staleTime: Infinity`, weil sich die Adressen waehrend einer Sitzung nicht
 * aendern — der Abruf passiert einmal und stoert danach nichts mehr.
 */
export const useContact = () => {
  const query = useQuery({
    queryKey: ["publicConfig"],
    staleTime: Infinity,
    queryFn: async () => {
      const response = await getPublicConfig();

      if (!response.data) {
        throw new Error("no data given");
      }

      return response.data;
    },
  });

  return query.data?.contact;
};
